<!-- 抽奖模块：抽盲盒 -->
<template>
  <div class="module-hd moduleHd_06">
    <!-- <div class="module-title">
      <img src="@/assets/images/activity/blind/luck_title.png" alt="">
    </div> -->
    <div class="mhd-content">
        <!-- <img src="@/assets/images/activity/blind/luck_draw.png" class="item-image" alt=""/> -->
        <div class="mhd-page">
            <div class="blind-box">
                <div class="get-prize-btn" v-if="drawStatus == 0">
                    <div class="btn"
                    @click="roulettePrize"></div>
                    <span class="prize-tootip">
                        <i class="txt tove">参与活动赢大奖</i>
                    </span>
                </div>
                <div class="get-prize-btn" v-else-if="drawStatus == 1">
                    <div class="btn btn02"
                    @click="copyLink"></div>
                    <span class="prize-tootip">
                        <i class="txt tove">开奖时间：{{ drawingTime }}</i>
                    </span>
                </div>
                <div class="get-prize-btn"  v-else-if="drawStatus == 2">
                    <div class="btn btn03"
                    @click="getCheatPrize"></div>
                    <span class="prize-tootip">
                        <i class="txt tove">参与活动赢大奖</i>
                    </span>
                </div>
            </div> 
            <div class="prize-list">
                <div class="prize-inner">
                    <div class="item"
                    v-for="(item, index) in prizeListData"
                    :key="index"
                    :class="{ first: index == 0, second: index == 1, third: index == 2 }">
                        <div class="inner df">
                            <div class="lt">
                                <img :src="item.vli_img" alt="" class="img">
                            </div>
                            <div class="rt f1">
                                <div class="tit limite-line-2">{{ item.vli_title }}</div>
                                <p class="txt">名额：{{ item.vli_virtual_num }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="berrage-list ofh df ai-c">
                <vue-danmaku
                ref="danmaku"
                v-model="barrageList"
                use-slot
                loop
                :speeds="60"
                :channels="3"
                :top="30"
                :right="80">
                    <template v-slot:dm="{ index, danmu }">
                    <div class="berrage-item df ai-c js-sb">
                        <img class="avatar" onerror="this.src='https://img12.yiihuu.com/60X60/upimg/avatar/default.jpg';this.onerror=null;" :src="danmu.avatar" alt="">
                        <span class="name tove">{{ danmu.name }}</span>
                        <span class="txt txt1">刚刚</span>
                        <span class="txt txt2">助力值+1</span>
                    </div>
                    </template>
                    <!-- <div></div> -->
                </vue-danmaku>
            </div>
            <div class="rank-btn" @click="showRankPopup"></div>
            <div class="gift-btn" @click="showMyPrize"></div>
        </div>
    </div>

    <!-- 助力排行榜 & 助力记录 弹窗 -->
    <div class="luckDraw-item" v-if="rankPopup">
        <div class="luckDraw-mantle" @click="togglePopup('rankPopup', false)"></div>
        <div class="luckDraw-layer luckDraw-rank">
            <div class="luckDraw-centent">
                <div class="tab-box">
                    <ul class="tab-tit df tac">
                        <li class="f1"
                        :class="{ active: rankCurTab == 0 }"
                        @click="switchTab('rankCurTab', 0)">助力排行榜</li>
                        <li class="f1"
                        :class="{ active: rankCurTab == 1 }"
                        @click="switchTab('rankCurTab', 1)">助力记录</li>
                    </ul>
                    <div class="tab-cnt">
                        <div class="cnt rank-cnt" v-show="rankCurTab == 0">
                            <ul>
                                <li class="item df ai-c js-sb"
                                v-for="(item, index) in rankListData"
                                :key="index"
                                :class="{ first: index == 0, second: index == 1, third: index == 2 }">
                                    <div class="lt df ai-c">
                                        <i class="num">{{ index + 1 }}</i>
                                        <img :src="item.member_head" alt="" class="avater">
                                        <p class="name tove">{{ item.member_name }}</p>
                                    </div>
                                    <div class="rt">
                                        <span>{{ item.cheat_count }}助力值</span>
                                    </div>
                                </li>
                            </ul>
                            <div class="item rank-bar df ai-c js-sb">
                                <div class="lt df ai-c">
                                    <p v-if="currUserRankData.rank">第{{ currUserRankData.rank }}名</p>
                                    <p v-else>未上榜</p>
                                    <img :src="currUserRankData.member_head" alt="" class="avater">
                                    <p class="name tove">我</p>
                                </div>
                                <div class="rt">
                                    <span>{{ currUserRankData.cheat_count }}助力值</span>
                                </div>
                            </div>
                        </div>
                        <div class="cnt record-cnt" v-show="rankCurTab == 1">
                            <ul>
                                <li class="item df ai-c js-sb"
                                v-for="(item, index) in selfCheatData"
                                :key="index">
                                    <div class="lt df ai-c">
                                        <img :src="item.member_head" alt="" class="avater">
                                        <p class="name tove">{{ item.member_name }}</p>
                                    </div>
                                    <div class="rt">
                                        <span>助力值+1</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
      
            <span class="luckDraw-close" @click="togglePopup('rankPopup', false)"></span>
        </div>
    </div>
  
    <!-- 我的礼品弹窗 -->
    <div class="luckDraw-item" v-if="prizePopup">
        <div class="luckDraw-mantle" @click="togglePopup('prizePopup', false)"></div>
        <div class="luckDraw-layer luckDraw-list">
            <div class="luckDraw-centent">
                <fieldset class="tit">
                    <legend>我的礼品</legend>
                </fieldset>
                <div class="cnt" v-if="myLotteryData.vli_id">
                    <div class="prize-box tac">
                        <img :src="myLotteryData.vli_img" alt="">
                        <p class="limite-line-2">{{ myLotteryData.vli_title }}</p>
                    </div>
              
                    <template v-if="myLotteryData.vli_type != 6 && myLotteryData.vli_type != 8"><!-- 非实物 -->
                        <div class="prize-other">
                            <p class="status tac">奖品已发送到您的账户，请注意查看</p>
                            <div class="btn ok-btn"
                            @click="prizePopup = false">我知道了</div>
                        </div>
                    </template>
                    <template v-else><!-- 实物 -->
                        <div class="prize-other prize-other2">
                            <p class="tips tac">*请核对收货信息，以免无法顺利收到奖品</p>
                            <el-form class="el-form prize-form"
                            ref="prizeForm"
                            :model="prizeForm"
                            :rules="rules"
                            :hide-required-asterisk="true"
                            :show-message="false">
                                <el-form-item class="df ai-c" label="收件人：" prop="name">
                                <el-input placeholder="" v-model="prizeForm.name"></el-input>
                                </el-form-item>
                                <el-form-item class="df ai-c" label="手机号码：" prop="phone">
                                <el-input placeholder="" v-model="prizeForm.phone"></el-input>
                                </el-form-item>
                                <el-form-item class="df" label="收货地址：" prop="address">
                                    <el-input
                                        type="textarea"
                                        placeholder=""
                                        v-model="prizeForm.address"
                                        resize="none">
                                    </el-input>
                                </el-form-item>
                            </el-form>
                            <div class="btns df">
                                <div class="btn ok-btn f1"
                                @click="submitForm">确认</div>
                                <div class="btn cancel-btn f1"
                                @click="prizePopup = false">取消</div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="cnt" v-else>
                    <div class="prize-other prize-other3 df ai-c js-c">
                        <p class="status tac">活动已结束，您未参与抽奖</p>
                    </div>
                </div>
            </div>
            <span class="luckDraw-close" @click="togglePopup('prizePopup', false)"></span>
        </div>
    </div>
    
    <bindWxPopup ref="bindWxPopup">
        <template v-slot:tit>
            参与成功
        </template>
        <template v-slot:tips>
            关注公众号获取开奖通知
        </template>
    </bindWxPopup>
</div>
</template>

<script>
import Vue from 'vue'
import Clipboard from 'v-clipboard'
Vue.use(Clipboard)
import Swiper from 'swiper'
import vueDanmaku from 'vue-danmaku'

import Cookies from 'js-cookie'

import { getToken } from '@/utils/auth'
import { header as getHeader, user as getUser } from '@/api/common'
import { activity as getActivity, getCoupons, acquirePoints, prizeList, selfCheat, cheatRecord, check, getPrize, cheatPrize, cheatTop, getLotteryLog, saveLotteryOther, ajaxWxLogin } from '@/api/activity/';

import { mapGetters, mapActions } from "vuex";

// import bindWxPopup from '@/components/bindWxPopup/'
const bindWxPopup = () => import('@/components/BindWxPopup')

export default {
  name: "BlindBoxTpl",
  components: {
    vueDanmaku,
    bindWxPopup,
  },
  data(){
    let checkPhoneFormat = (rule, value, callback) => {
      if (!/(^1[3|4|5|6|7|8|9][0-9]{9}$)/.test(value)) {
        callback(new Error('请输入正确手机号'));
      } else {
        callback();
      }
    };
    return {
      activityType: null,
      luckDrawType: false,
      luckType: 0,
      luckText: "",
      isture: false,//是否抽奖中，防止重复点击
      // prizeAni: false,//显示抽奖动画
      member: null,
      memberPoints: 0,//积分
      timer: "",
      lottery_id: 15, //抽奖id(新抽奖活动，必改)
      luck_prize: "",
      luck_points: 0,//抽中积分数

      qrCodeUrl: '',
      barrageList: [],//弹幕数据
      lotteryTimes: 1,//可抽奖次数
      rankPopup: false,
      prizePopup: false,
      myLotteryList: [],

      memberId: '',
      TG: '',
      bind_wx: 0,//是否已绑定微信
      prizeListData: [],
      cheatTopData: [],
      selfCheatData: [],
      rankListData: [],
      currUserRankData: {},
      myLotteryData: {},
      hasDrawn: 0,//是否已开奖
      drawingTime: '',//开奖时间，格式如：2024.1.10 10:00
      hasPrize: 0,//是否已参与抽奖
      drawStatus: 0,//抽奖按钮：0:未抽奖 1：已抽奖(邀请朋友助力) 2：助力(助力并参与)
      rankCurTab: 0,
      rules: {
        name: [
          {
            required: true,
            message: "请输入收件人",
            trigger: ["blur", "change"]
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: ["blur", "change"]
          },
          { validator: checkPhoneFormat, trigger: 'blur' },
        ],
        address: [
          {
            required: true,
            message: "请输入收货地址",
            trigger: ["blur", "change"]
          },
        ]
      },
      prizeForm: {
        name: '',
        phone: '',
        address: ''
      }
    }
  },
  watch: {
    "$store.getters.MemberInfo": {
      deep: true,
      handler(val) {
        if (this.isLogin) {
          this.member = val
          let { member_points, bind_wx, member_id } = this.member
          this.memberPoints = member_points
          this.bind_wx = bind_wx
          this.memberId = member_id
          // if (this.activityType == 'zt') {
            this.checkLotteryNum()
          // }
        }
      }
    }
  },
  computed: {
    ...mapGetters(["token", "MemberInfo"]),
    isLogin() {
      return this.$store.getters.token
    }
  },
  created() {
    let params = this.$route.params
    // console.log(`params:${JSON.stringify(params)}`)
    this.activityType = params.activity_type
    this.activityId = params.activity_id

    // if (this.activityType == 'zt') {
      // 开奖时间
      let time = new Date(2024, 2, 1, 10, 0, 0),//月份从0开始计数
        now = Date.now();
      this.setDrawingTime(time)
      if (now - time > 0) {
        this.hasDrawn = true
      }

      let query = this.$route.query

      if (query['TG']) {
        this.TG = query['TG']
        this.drawStatus = 2
      }

      this.getPrizeList()

      this.get_lottery_log()
    // }
  },
  mounted() {

  },
  methods: {
    async getPrizeList() {
      let params = {
        lottery_id: this.lottery_id,
      }
      let res = await prizeList(params)
      let { data } = res
      this.prizeListData = data.map((item, index) => {
        item.vli_img = require(`@/assets/images/activity/draw/prize/${index}.png`)
        return item
      })
    },
    //抽奖按钮
    async roulettePrize() {

      if (!this.isLogin) {
        this.showLogin()
        return
      }

      if (this.isture) {
        return
      }

      if (!this.bind_wx) {
        this.showWxMsg()
        return
      }

      this.isture = true
      let params = {
        lottery_id: this.lottery_id
      }
      let res = await getPrize(params).catch(() => {
        this.isture = false
        return false
      })
      if (!res) return

      this.isture = false
      this.drawStatus = 1

      this.showWXBindDialog()

      this.$layer.msg('参与成功 等待开奖')
    },
    async getCheatPrize() {
      if (!this.isLogin) {
        this.showLogin()
        return
      }

      if (this.isture) {
        return
      }

      if (!this.bind_wx) {
        this.showWxMsg()
        return
      }

      this.isture = true
      let params = {
        lottery_id: this.lottery_id,
        cheat_uid: this.TG,
        show_error_msg: false
      }
      let res = await cheatPrize(params).then((res2) => {
        let { code, data, msg } = res2
        this.isture = false
        if (code == 0) {
          this.drawStatus = 1
          this.$layer.msg('恭喜您，助力好友成功')

          //刷新助力记录
          this.get_lottery_log()
        } else if (code == 2002) { //活动期间已为好友助力过,改为复制链接
          this.drawStatus = 1
        } else {
          this.$message.error(msg)
        }
      }).catch(() => {
        this.isture = false
        return false
      })
    },
    //抽奖弹窗按钮
    luckLayer() {
      this.luckDrawType ? this.luckDrawType = false : this.luckDrawType = true;
    },
    //助力记录
    async get_lottery_log() {
      let params = {
        lottery_id: this.lottery_id,
      }
      let res = await cheatRecord(params)

      this.barrageList = []
      let { data } = res
      $.each(data, (k, v) => {
        let tempItem = {}
        tempItem.avatar = v.member_head
        tempItem.name = v.member_name
        // tempItem.prize = v.vli_title
        this.barrageList.push(tempItem)
      });
    },
    async get_mylottery_log() {
      let params = {
        lottery_id: this.lottery_id,
      }
      let res = await getLotteryLog(params)

      // 未抽过奖
      if (!res.data.length) return

      this.myLotteryData = res.data[0]

      let index = this.prizeListData.findIndex((item) => {
        return item['vli_id'] == this.myLotteryData['vli_id']
      })
      this.myLotteryData.vli_img = this.prizeListData[index]['vli_img']

      let { name, phone, address } = this.myLotteryData
      this.prizeForm.name = name
      this.prizeForm.phone = phone
      this.prizeForm.address = address
    },
    showLogin() {
      this.$layer.msg('请先登录');
      setTimeout(() => {
        window.location.href = process.env.VUE_APP_LOGIN_API + '/m_login.html?v=3&target_uri=' + location.href;
      }, 600);
    },
    async checkLotteryNum() {//检查是否已抽奖
      if (this.hasDrawn && !Cookies.get('shownMyPrize')) {//已开奖 && 未显示过中奖弹窗
        this.showMyPrize()
        Cookies.set('shownMyPrize', 1, { expires: 7 })
      }

      let params = {
        lottery_id: this.lottery_id
      }
      let res = await check(params)
      this.hasPrize = res.data
      if (this.hasPrize == 1 && !this.$route.query['TG']) {//已抽过奖 && 非助力
        this.drawStatus = 1
      }
    },
    async showRankPopup() {
      if (!this.isLogin) {
        this.showLogin()
        return
      }

      this.togglePopup('rankPopup', true)

      let params = {
        lottery_id: this.lottery_id
      }
      let res = await cheatTop(params)
      let { rankList, currUserRank } = res.data
      this.rankListData = rankList
      this.currUserRankData = currUserRank

      let res2 = await selfCheat(params)
      this.selfCheatData = res2.data

    },
    showMyPrize() {
      if (!this.isLogin) {
        this.showLogin()
        return
      }

      if (!this.bind_wx) {
        this.showWxMsg()
        return
      }

      if (!this.hasDrawn) {//未到开奖时间
        this.$layer.msg('请您等待开奖')
        return
      }

      this.togglePopup('prizePopup', true)
      this.get_mylottery_log()
    },
    togglePopup(name_, boolean_) {
      this[name_] = boolean_
    },
    switchTab(name_, val_) {
      this[name_] = val_
    },
    async submitForm() {
      await this.$refs['prizeForm'].validate(async (valid, obj) => {
        if (valid) {
          let params = {
            vll_id: this.myLotteryData.vll_id,
            ...this.prizeForm
          }
          let res = await saveLotteryOther(params)
          this.$layer.msg('已成功提交收货信息')
          this.prizePopup = false
        } else {
          let item = obj.name || obj.phone || obj.address
          let msg = item[0]['message']
          this.$layer.msg(msg)
          return false
        }
      });
    },
    setDrawingTime(date_) {
      let year = date_.getFullYear()
      let month = date_.getMonth() + 1
      let day = date_.getDate()
      let hours = date_.getHours()
      let minutes = date_.getMinutes()
      let seconds = date_.getSeconds()

      hours = this.addZero(hours)
      minutes = this.addZero(minutes)
      seconds = this.addZero(seconds)

      this.drawingTime = `${year}.${month}.${day} ${hours}:${minutes}`
    },
    addZero(num_) {
      return num_ < 10 ? `0${num_}` : num_
    },
    showWxMsg() {
      this.$layer.msg('微信登录用户即可参与抽奖')
    },
    showWXBindDialog() {
      this.$refs['bindWxPopup'].show()
    },
  }
}
</script>
<style lang="scss" scoped>
.module-hd{
  // width: calc(100% - 30px);
  // position: relative;
  // margin: 0 auto;
  // z-index: 9;
  .module-title{
      width: 100%;
      margin-bottom: 20px;
      img{
          width: 570px;
          display: block;
          margin: 0 auto;
      }
  }
  .mhd-content{
      width: 100%;
      position: relative;
      .item-image{
          width: 100%;
          display: block;
      }
      .mhd-page{
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
      }
  }
  &:not(:last-child){ margin-bottom: 50px; }
  &.moduleHd_06{
      width: 100%!important;
      z-index: 10;
      .mhd-content{
          height: 1711px;
          background: #FF9393;
          border-radius: 0;
          .item-image{
              display: none;
          }
          .mhd-page{
              padding: 261px 0 0px;
              .blind-box{
                  width: 682px;
                  height: 743px;
                  margin: 0 auto;
                  padding-top: 518px;
                  box-sizing: border-box;
                  background: url('~@/assets/images/activity/draw/draw_box_bg.png')  -18px 0/682px 743px no-repeat;
                  position: relative;
                  .get-prize-btn{
                      display: block;
                      width: 294px;
                      height: 94px;
                      margin: 0 auto;
                      position: relative;
                      .btn{
                      width: 100%;
                      height: 100%;
                      cursor: pointer;
                      background: url('~@/assets/images/activity/draw/draw_btn01.png')  0 0/100% 100% no-repeat;
                      transition: all .3s;
                      &.btn02{
                          background-image: url('~@/assets/images/activity/draw/draw_btn02.png');
                      }
                      &.btn03{
                          background-image: url('~@/assets/images/activity/draw/draw_btn03.png');
                      }
                      // &.disable{
                      //     // cursor: default;
                      //     background: url('~@/assets/images/activity/blind/punch_disable_btn.png')  0 0/100% 100% no-repeat;
                      //     &:active{
                      //         transform: scale(1);
                      //     }
                      // }
                      // &:active{
                      //     transform: scale(.95);
                      // }
                      }
                      .prize-tootip{
                          height: 36px;
                          line-height: 36px;
                          position: absolute;
                          left: 50%;
                          bottom: 100%;
                          margin:0 auto 14px;
                          transform: translate(-50%,0);
                          color: #fc8629;
                          font-size: 20px;
                          cursor: default;
                          padding: 0 28px;
                          background-color: #fff;
                          border-radius: 18px;
                          box-shadow: inset -1px -1px 4px rgba(0,0,0,.3), 2px 2px 4px rgba(237,110,26,6);
                          .txt{
                              display: block;
                              // max-width: 298px;
                              height: 100%;
                              white-space: nowrap;
                              font-style: normal;
                              position: relative;
                              z-index: 1;
                          }
                          &::after{
                              content:'';
                              width: 26px;
                              height: 50px;
                              position: absolute;
                              left: 0;
                              right: 0;
                              top: 0;
                              margin:0 auto;
                              background: url('~@/assets/images/activity/draw/tootips_bg.png')  0 0/100% 100% no-repeat;
                          }
                      }
                      .prize-tips{
                          width: 176px;
                          line-height: 40px;
                          color: #fff;
                          text-align: center;
                          background: rgba(0,0,0,0.32);
                          border-radius: 6px;
                          position: absolute;
                          left: 0;
                          right: 0;
                          bottom: 100%;
                          margin:0 auto 36px;
                      }
                  }
              }
              .prize-list{
                  width: 706px;
                  height: 791px;
                  margin: -126px auto 0;
                  padding:104px 0 4px;
                  background: url('~@/assets/images/activity/draw/prize_bg.png')  0 0/100% 100% no-repeat;
                  position: relative;
                  .prize-inner{
                      height: 100%;
                      margin: 0 5px;
                      padding: 0 24px 12px;
                      overflow-y: auto;
                      display: grid;
                      grid-template-columns: repeat(1,1fr);
                      grid-gap:16px 0;
                      .item{
                          // height: 176px;
                          padding:14px;
                          background: #fff;
                          border-radius: 10px;
                          .inner{
                              height: 100%;
                          }
                          .lt{
                              margin-right: 24px;
                              .img{
                                  width: 264px;
                                  height: 166px;
                                  border-radius: 15px;
                              }
                          }
                          .rt{
                              position: relative;
                              .tit{
                                  font-size: 26px;
                              }
                              .txt{
                                  color: #717171;
                                  font-size: 24px;
                                  position: absolute;
                                  bottom: 4px;
                              }
                          }
                          &.first,
                          &.second,
                          &.third{
                              padding: 5px;
                              position: relative;
                              .inner{
                                  padding: 12px;
                                  border-radius: 10px;
                              }
                              &::before{
                                  content:'';
                                  width: 50px;
                                  height: 24px;
                                  position: absolute;
                                  left: 14px;
                                  bottom: 100%;
                              }
                          }
                          &.first{
                              background:linear-gradient(135deg, rgba(255, 247, 219, 1), rgba(255, 225, 120, 1));
                              .inner{
                                  background: linear-gradient(135deg, #FFF8E1 0%, #FFFFFF 67%);
                              }
                              // &::before{
                              //     background: url('~@/assets/images/activity/draw/ico_crown01.png')  0 0/100% 100% no-repeat;
                              // }
                          }
                          &.second{
                              padding: 4px;
                              background:linear-gradient(135deg, rgba(238, 243, 250, 1), rgba(220, 231, 248, 1));
                              .inner{
                                  background: linear-gradient(135deg, #EAF0F8 0%, #FFFFFF 71%);
                              }
                              // &::before{
                              //     background: url('~@/assets/images/activity/draw/ico_crown02.png')  0 0/100% 100% no-repeat;
                              // }
                          }
                          &.third{
                              padding: 2px;
                              background:linear-gradient(135deg, rgba(227, 184, 128, 1), rgba(255, 230, 196, 1), rgba(227, 184, 128, 1));
                              .inner{
                                  background: linear-gradient(135deg, #FFF5E8 0%, #FFFFFF 71%);
                              }
                              // &::before{
                              //     background: url('~@/assets/images/activity/draw/ico_crown03.png')  0 0/100% 100% no-repeat;
                              // }
                          }
                      }
                  }
              }
              .berrage-list{
                  width: 100%;
                  height: 300px;
                  position: absolute;
                  left: 0;
                  top: 124px;
                  z-index: 1;
                  ::v-deep .vue-danmaku{
                      width: 100%;
                      height: 100%;
                      .dm{
                          width: auto!important;
                      }
                  }
                  .berrage-item{
                      // max-width: 248px;
                      min-width: 350px;
                      // margin:20px 27px 0;
                      line-height: 46px;
                      padding:0 20px 0 6px;
                      color: #333;
                      font-size: 26px;
                      background-color: #fff;
                      border-radius: 46px;
                      box-shadow: 2px 2px 5px rgba(0,0,0,0.19);
                      .name{
                          // max-width: 80px;
                          max-width: 4em;
                      }
                      .avatar{
                          width: 34px;
                          height: 34px;
                          margin-right: 10px;
                          border-radius: 50%;
                      }
                      .txt{
                          white-space: nowrap;
                      }
                      .txt1{
                          margin: 0 10px;
                          color: #777;
                          font-size: 26px;
                      }
                  }
              }
              .rank-btn{
                  width: 140px;
                  height: 140px;
                  cursor: pointer;
                  background: url('~@/assets/images/activity/draw/rank.png')  0 0/100% 100% no-repeat;
                  position: absolute;
                  left: 0;
                  top: 767px;
                  transition: all .3s;
              }
              .gift-btn{
                  width: 140px;
                  height: 140px;
                  cursor: pointer;
                  background: url('~@/assets/images/activity/draw/prize.png')  0 0/100% 100% no-repeat;
                  position: absolute;
                  right: 0;
                  top: 767px;
                  transition: all .3s;
              }
          }
          
      }
  }
}

.luckDraw-item{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    .luckDraw-mantle{
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        position: absolute;
        top: 0;
        left: 0;
        z-index: 8;
    }
    .luckDraw-layer{
        width: 552px;
        // height: 300px;
        // background-image: url("~@/assets/images/activity/prize_item.png");
        // background-repeat: no-repeat;
        // background-position: top center;
        // background-size: cover;
        background:#fff;
        background-clip:padding-box;
        border: 15px solid rgba(255,255,255,0.3);
        border-radius: 25px;
        position: relative;
        -webkit-animation-name: layer-bounceIn;
        animation-name: layer-bounceIn;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
        -webkit-animation-duration: 0.3s;
        animation-duration: 0.3s;
        z-index: 9;
        .luckDraw-close{
            width: 50px;
            height: 50px;
            background-image: url("~@/assets/images/activity/draw/close.png");
            background-repeat: no-repeat;
            background-position: top center;
            background-size: cover;
            border-radius: 50%;
            position: absolute;
            bottom: 100%;
            left: 100%;
            margin:0 0 15px 15px;
            transition: all ease 0.2s;
            cursor: pointer;
            &:hover{
                transform: scale(1.117);
            }
        }
        .luckDraw-centent{
            width: 100%;
            // height: 100%;
            // min-height: 253px;
            position: relative;
            box-sizing: border-box;
            // background: url("~@/assets/images/activity/prize_item02.png") 0 0/100% auto no-repeat;
            &.luckDraw-recharge{
                padding-top: 54px;
                text-align: center;
                .recharge-text{
                    width: 100%;
                    line-height: 46px;
                    font-size: 34px;
                    color: #fff;
                    font-weight: bold;
                    span{
                        color: #d50101;
                    }
                }
                // .luckDraw-button{
                //     background-image: url("~@/assets/images/activity/prize_button.png");
                //     &:hover{
                //         background-image: url("~@/assets/images/activity/prize_button_hover.png");
                //     }
                // }
            }
            &.luckDraw-prize{
                padding-top: 54px;
                .prize-text{
                    width: 100%;
                    text-align: center;
                    p{
                        width: 100%;
                        &.txt1{
                            height: 30px;
                            line-height: 30px;
                            font-size: 30px;
                            color: #fff;
                            font-weight: bold;
                            // margin-bottom: 12px;
                        }
                        &.txt2{
                            height: 36px;
                            line-height: 36px;
                            font-size: 36px;
                            color: #fff;
                            font-weight: bold;
                            margin-bottom: 20px;
                        }
                        &.txt3{
                            height: 22px;
                            line-height: 22px;
                            margin-top: 20px;
                            font-size: 22px;
                            color: #fff;
                        }
                    }
                    .link{
                        display: block;
                        margin: 16px auto 0;
                        color: #76b5ff;
                        font-size: 24px;
                        text-decoration: underline;
                    }
                    .qrcode{
                        width: 200px;
                        // margin-bottom: 10px;
                    }
                }
                .luckDraw-button{
                    cursor: pointer;
                    // background-image: url("~@/assets/images/activity/prize_hide.png");
                    // &:hover{
                    //     background-image: url("~@/assets/images/activity/prize_hide_hover.png");
                    // }
                    // &.luckDraw-button-txt{
                    //     background-image: url("~@/assets/images/activity/prize_hide_txt.png");
                    //     &:hover{
                    //         background-image: url("~@/assets/images/activity/prize_hide_txt_hover.png");
                    //     }
                    // }
                }
            }
            .luckDraw-button{
                display: block;
                width: 232px;
                height: 73px;
                line-height: 68px;
                margin: 20px auto 0;
                text-align: center;
                color: #fff;
                font-weight: 700;
                font-size: 29px;
                background-image: url("~@/assets/images/activity/prize_hide_txt.png");
                background-repeat: no-repeat;
                background-position: top center;
                background-size: cover;
                // position: absolute;
                // bottom: 40px;
                // left: 50%;
                // transform: translate(-50%,0);
                transition: all ease 0.2s;
                &:hover{
                    color: #6C5400;
                    opacity: .95;
                    // background-image: url("~@/assets/images/activity/prize_hide_txt_hover.png");
                }
            }
        }
        &.luckDraw-rank{
            .tab-box{
                .tab-tit{
                    margin:-15px 15px 0;
                    li{
                        height:66px;
                        line-height:76px;
                        color: #f90;
                        font-size: 32px;
                        cursor:pointer;
                        &.active{
                            line-height:66px;
                            color:#fff;
                            font-weight:700;
                            background: #f90;
                            border-radius:10px;
                        }
                    }
                }
                .tab-cnt{
                    .cnt{
                      height:620px;
                      padding-top: 25px;
                      padding-bottom: 72px;
                      ul{
                        height: 100%;
                        padding-bottom: 20px;
                        overflow-y: auto;
                      }
                      .item{
                        font-size:24px;
                        .avater{
                            width:38px;
                            height:38px;
                            margin:-9px 10px 0;
                            border-radius:50%;

                        }
                      }
                      &.rank-cnt{
                        .item{
                            height: 70px;
                            margin: 16px 16px 0;
                            padding: 0 20px 0 12px;
                            border-radius: 43px;
                            border: 1px solid #EBEEF6;
                            &:first-child{
                                margin-top: 0;
                            }
                            .num{
                                width: 54px;
                                height: 54px;
                                line-height: 54px;
                                overflow: hidden;
                                color: #fff;
                                font-size: 20px;
                                font-weight: 700;
                                font-style: normal;
                                text-align: center;
                                text-indent: 5px;
                                background: url("~@/assets/images/activity/draw/rank_bg.png") 50% 50%/100% 100% no-repeat;
                            }
                            .name{
                                max-width: 140px;
                            }
                            &.first,
                            &.second,
                            &.third{
                                .num{
                                    text-indent: -9999em;
                                }
                            }
                            &.first{
                                background: rgba(255, 243, 120, 0.22);
                                border: none;
                                .num{
                                    background: url("~@/assets/images/activity/draw/rank_1.png") 50% 50%/100% 100% no-repeat;
                                }
                            }
                            &.second{
                                background: rgba(193, 226, 251, 0.17);
                                border: none;
                                .num{
                                    background: url("~@/assets/images/activity/draw/rank_2.png") 50% 50%/100% 100% no-repeat;
                                }
                            }
                            &.third{
                                background: rgba(248, 154, 120, 0.17);
                                border: none;
                                .num{
                                    background: url("~@/assets/images/activity/draw/rank_3.png") 50% 50%/100% 100% no-repeat;
                                }
                            }
                            &.rank-bar{
                                height: 72px;
                                margin: 0;
                                padding: 0 36px 0 34px;
                                color: #fff;
                                font-size: 20px;
                                background: #FD9020;
                                border-radius: 0 0 10px 10px;
                                border: none;
                            }
                        }
                      }
                      &.record-cnt{
                        padding-bottom: 20px;
                        .item{
                            height: 62px;
                            margin: 20px 16px 0;
                            padding: 0 20px 0 12px;
                            font-size: 24px;
                            background: #F6F8FC;
                            border-radius: 58px;
                            &:first-child{
                                margin-top: 0;
                            }
                            .name{
                                color: #777;
                                font-size: 22px;
                            }
                        }
                      }
                    } 
                }
            }
        }
        &.luckDraw-list{
            width: 600px;
            min-height: 626px;
            padding: 30px 0;
            .tit{
                text-align: center;
                color: #f90;
                font-size: 32px;
                font-weight: 700;
                border-top: 1px solid #f90;
                legend{
                    padding: 0 6px;
                }
            }
            .cnt{
                padding: 8px 64px 0;
                color: #333;
                .prize-box{
                    // width: 442px;
                    min-height: 248px;
                    margin: 0 auto;
                    padding: 20px 18px;
                    background: #E9EDF6;
                    border-radius: 10px;
                    img{
                        width: 264px;
                        height: 166px;
                    }
                    p{
                        padding-top: 10px;
                        font-size: 24px;
                    }
                }
                .prize-other{

                }
                .tips{
                    padding: 13px 0 28px;
                    color: #f95252;
                    font-size: 24px;
                }
                .status{
                    padding: 40px 0 40px;
                    font-size: 32px;
                }
                .btn{
                    width: 312px;
                    height: 60px;
                    line-height: 60px;
                    margin: 0 auto;
                    color: #fff;
                    font-size: 28px;
                    text-align: center;
                    cursor: pointer;
                    background: #f90;
                    border-radius: 82px;
                }
                .prize-other2{
                    // padding: 0 40px;
                    ::v-deep .prize-form{
                        .el-form-item{
                            margin-bottom: 16px;
                            &.is-error{
                                .el-input__inner,
                                .el-textarea__inner{
                                    border-color: #F56C6C;
                                }
                            }
                        }
                        .el-form-item__label{
                            width: 5em;
                            padding-right: 9px;
                            line-height:40px;
                            font-size: 24px;
                            text-align: left;
                            white-space: nowrap;
                        }
                        .el-input__inner,
                        .el-textarea__inner{
                            font-size: 24px;
                            border: 1px solid #ddd;
                            border-radius: 10px;
                        }
                        .el-input__inner{
                            height:40px;
                            line-height:40px;
                            padding: 0 15px;
                        }
                        .el-textarea__inner{
                            height: 80px;
                            padding: 5px 15px;
                        }
                        .el-form-item__content{
                            flex:1;
                            line-height:40px;
                        }
                    }
                    .btns{
                        padding-top: 12px;
                        .ok-btn{
                            margin-right: 18px;
                        }
                        .cancel-btn{
                            background: #C3C3C3;
                        }
                    }
                }
                .prize-other3{
                    height:402px;
                }
            }
            // .cnt{
            //     max-height: 375px;
            //     padding: 0 27px;
            //     overflow: auto;
            //     li{
            //         height: 80px;
            //         margin: 10px 0 0;
            //         // padding: 0 50px;
            //         font-size: 18px;
            //         font-weight: 700;
            //         border-radius: 10px;
            //         border: 2px solid rgba(255,249,228,0.5);
            //         span{
            //             padding: 0 50px;
            //             &:nth-child(2){
            //                 padding:0;
            //                 font-weight: 400;
            //             }
            //         }
            //     }
            //     &::-webkit-scrollbar{//自定义滚动条样式
            //         width: 4px;
            //     }
            //     &::-webkit-scrollbar-button{
            //         display: none;
            //     }
            //     &::-webkit-scrollbar-thumb{
            //         background-color: rgba(255,249,228,0.5);
            //         border-radius: 3px;
            //     }
            // }
        }
    }
}
.prize-inner,
.tab-cnt .cnt ul{
    &::-webkit-scrollbar{
        width: 4px;
        height: 4px;
    }
    &::-webkit-scrollbar-track-piece{
        background:transparent;
    }
    &::-webkit-scrollbar-thumb{
        border-radius:35px;
        background-color: rgba(255,255,255,0.58);
    }
}
.tab-cnt .cnt ul{
    &::-webkit-scrollbar-thumb{
        border-radius:35px;
        background-color: rgba(255, 153, 0, 0.25);
    }
}
@-webkit-keyframes layer-bounceIn{
    0% {
        opacity: 0;
        -webkit-transform: scale(.5);
        transform: scale(.5)
    }
    100% {
        opacity: 1;
        -webkit-transform: scale(1);
        transform: scale(1)
    }
}
@keyframes layer-bounceIn{
    0% {
        opacity: 0;
        -webkit-transform: scale(.5);
        -ms-transform: scale(.5);
        transform: scale(.5)
    }
    100% {
        opacity: 1;
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1)
    }
}
</style>